import React from 'react';
import { AlertTriangle, TrendingDown, Users } from 'lucide-react';

const Crisis = () => {
  return (
    <section id="crisis" className="relative py-24 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-[#E63946]/10 border border-[#E63946]/30 rounded-full px-6 py-2 mb-6">
            <AlertTriangle className="w-5 h-5 text-[#E63946]" />
            <span className="text-[#E63946] font-bold text-sm">URGENT CRISIS</span>
          </div>
          <h2 className="text-5xl sm:text-6xl md:text-7xl font-bold text-white mb-6" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
            CALIFORNIA IS
            <span className="block text-[#E63946]">DEFUNDING REHABILITATION</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            As state funding for rehabilitation programs disappears, thousands are being left without the resources they need to transform their lives.
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] border border-[#E63946]/20 rounded-xl p-8 transform hover:scale-105 transition-all duration-300">
            <div className="w-14 h-14 bg-[#E63946]/10 rounded-lg flex items-center justify-center mb-4">
              <TrendingDown className="w-8 h-8 text-[#E63946]" />
            </div>
            <div className="text-4xl font-bold text-[#E63946] mb-2" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              -40%
            </div>
            <p className="text-gray-300 font-medium mb-2">Funding Cut</p>
            <p className="text-gray-500 text-sm">State rehabilitation programs facing massive budget reductions</p>
          </div>

          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] border border-[#E63946]/20 rounded-xl p-8 transform hover:scale-105 transition-all duration-300">
            <div className="w-14 h-14 bg-[#E63946]/10 rounded-lg flex items-center justify-center mb-4">
              <Users className="w-8 h-8 text-[#E63946]" />
            </div>
            <div className="text-4xl font-bold text-[#E63946] mb-2" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              10,000+
            </div>
            <p className="text-gray-300 font-medium mb-2">People Affected</p>
            <p className="text-gray-500 text-sm">Incarcerated individuals losing access to rehabilitation resources</p>
          </div>

          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] border border-[#E63946]/20 rounded-xl p-8 transform hover:scale-105 transition-all duration-300">
            <div className="w-14 h-14 bg-[#E63946]/10 rounded-lg flex items-center justify-center mb-4">
              <AlertTriangle className="w-8 h-8 text-[#E63946]" />
            </div>
            <div className="text-4xl font-bold text-[#E63946] mb-2" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              NOW
            </div>
            <p className="text-gray-300 font-medium mb-2">Action Needed</p>
            <p className="text-gray-500 text-sm">Every donation directly fills the gap left by budget cuts</p>
          </div>
        </div>

        {/* Impact Statement */}
        <div className="bg-gradient-to-r from-[#1a1a1a] via-[#E63946]/5 to-[#1a1a1a] border border-[#E63946]/30 rounded-2xl p-8 md:p-12">
          <div className="max-w-4xl mx-auto">
            <p className="text-2xl md:text-3xl text-white font-semibold mb-6 leading-relaxed">
              "Without programs like 40 Songs and a Mic, these individuals lose more than just resources. They lose hope, purpose, and the path to redemption."
            </p>
            <div className="flex items-center space-x-4">
              <div className="w-1 h-12 bg-[#E63946]" />
              <div>
                <p className="text-[#D4AF37] font-bold">The Reality</p>
                <p className="text-gray-400 text-sm">When rehabilitation programs disappear, recidivism rates soar and communities suffer</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Crisis;
